<template>
  <div>
    <div class="solution-page container bg-white" v-if="page == 1">
      <el-row v-if="1 === 0">
        <el-col :span="24">
          <div class="f-view-r-c-r bg-brown">
            <el-image src="../../static/images/u-logo.png"></el-image>
            <el-button type="warning" round @click="openApp">打开APP</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="24"
          class="f-view-r-c-c margin-t-20"
          v-if="!vipDialogVisible"
        >
          <el-image :src="data.cover" fit="fit"></el-image>
        </el-col>
        <el-col :span="24" class="f-view-r-c-c margin-t-20" v-else>
          <img src="/static/images/bg-black-zg@3x.png" />
          <div class="pos-abs text-align-c">
            <div
              class="font-size-18 text-color-white font-weight-bold"
              style="font-size: 28px"
            >
              仅需9.9开通会员<br />即可收听本站全部内容
            </div>
            <el-button type="danger" class="btn-pink margin-t-10"
              style="width:6rem;height:2rem;" @click="openApp()">立即下载</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="margin-t-20">
          <div class="aui-card-list-content">
            <ul class="aui-list aui-media-list">
              <li
                class="aui-list-item aui-list-item-middle"
                style="border-top: 1px solid #ffffff; margin-bottom: -1px;"
              >
                <div class="aui-media-list-item-inner">
                  <div class="aui-list-item-media" style="width: 4rem">
                    <img :src="data.cover" />
                  </div>
                  <div class="aui-list-item-inner">
                    <div class="aui-list-item-text">
                      <div
                        class="aui-list-item-title font-size-18 text-color-black"
                        style="font-weight: bold"
                      >
                        {{ data.full_name }}
                      </div>
                    </div>
                    <div class="aui-list-item-text font-size-16">
                      {{ authorData.author }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="aui-card-list">
            <div class="userinfo-header">
              <div class="aui-info">
                <div class="aui-info-item">
                  <span class="margin-l-10 font-size-14 text-color-black"
                    >简介</span
                  >
                </div>
                <div class="aui-info-item margin-r-10 font-size-12">
                  禁止二传二改及商用
                </div>
              </div>
            </div>
            <div class="aui-card-list-content-padded text-color-gray">
              <div v-if="!isExpanded" class="clampedCon" ref="clampedContent">
                {{ data.intro }}
              </div>
              <div v-else class="clampedCon expanded">
                {{ data.intro }}
              </div>
              <div class="toggle-button" @click="toggleExpand" v-if="showToggleButton">
                <span class="shadowLine"></span>
                <span class="expandedText">
                  {{ isExpanded ? '关闭全部' : '展开全部' }}
                  <i :class="`el-icon-caret-${isExpanded ? 'top' : 'bottom'}`" style="ma"></i></span>
                <span class="shadowLine"></span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="text-align-c padding-15" @click="openApp()">
            <div
              class="bg-gray-light"
              style="border-radius: 70px; padding: 15px 0px"
            >
              <div class="font-size-14">
                还不够？APP内尽情探索吧<i class="el-icon-caret-right"></i>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div style="padding: 0px 15px 0px 30px">
            <audioComponent
              :audioList="audioData"
              ref="refAudio"
              v-if="visible"
              :key="getRandomKey()"
            ></audioComponent>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="margin-t-10 padding-10">
          <img src="/static/images/download@3x.png" @click="openApp()" />
        </el-col>
      </el-row>

      <div class="aui-tips fixed-alert padding-10">
        <div class="aui-tips-title f-view-r-c-c">
          <img src="/static/images/u-logo-mini.png" style="width:1.2rem;height:1.2rem;border-radius:0.3rem;"/>
          <div class="margin-l-5">前往兔U，发现更多好声音</div>
        </div>
        <el-button type="danger" size="mini" class="btn-pink" @click="openApp()"
          >立即打开</el-button
        >
      </div>
      <el-row v-if="1 === 0">
        <div class="padding-20">
          <div class="font-size-18"><h5>章节</h5></div>
          <el-col
            :span="24"
            class="margin-t-20"
            v-for="(item, index) in soundList"
            :key="index"
          >
            <div
              :class="{ 'text-color-pink': currentSoundIndex === index }"
              @click="onPlaySound(index)"
            >
              {{ item.soundInfo.full_name }}
            </div></el-col
          >
        </div>
      </el-row>
    </div>
    <div v-if="page == 2">
      <el-row>
        <el-col :span="24" class="f-view-r-c-r ">
          <img src="/static/images/to-browser@3x.png" style="width:70%"/>
        </el-col>
      </el-row>
    </div>
    <div v-if="page == 3">
      <el-dialog
        title="请先下载客户端"
        :visible.sync="centerDialogVisible"
        width="90%"
        center
      >
        <p>下载APP</p>
        <p>收听更多精彩广播剧</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" round @click="centerDialogVisible = false"
            >取 消</el-button
          >
          <el-button type="warning" round @click="download()">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <el-dialog
      title=""
      :visible.sync="vipDialogVisible"
      width="90%"
      center
      :show-close="false"
      :close-on-click-modal="false"
    >
      <span>本集为VIP章节，请下载APP收听</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="download()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import audioComponent from "@/components/common/audio";

export default {
  name: "solution",
  data() {
    return {
      data: {},
      authorData: {},
      soundList: [],
      currentSoundIndex: 0,
      centerDialogVisible: true,
      vipDialogVisible: false,
      audioData: {},
      page: 1,
      visible: false,
      isExpanded: false, // 新增属性
      showToggleButton: true, // 新增属性
    };
  },
  components: {
    audioComponent,
  },
  methods: {
    init() {
      var requestData = {
        albumId: this.albumId || 0,
        albumSoundId: this.albumSoundId || 0,
        userId: 0,
      };
      this.$api.albumInfo(requestData).then((res) => {
        //const response = JSON.stringify(res)
        let response = JSON.parse(res);
        const { data } = response
        this.data = data
        if (data.url === '') {
          this.vipDialogVisible = true;
          return;
        }

        this.audioData = {
          url: data.url,
          title: data.full_name,
          artist: data.full_name,
          totalTime: data.duration,
          artwork: [
            {
              src: data.cover,
              sizes: "512x512",
              type: "image/png",
            },
          ],
        };
        this.visible = true;

        this.$nextTick(() => {
          this.calculateContentHeight();
        });
      });

      this.$api.authorData(requestData).then((res) => {
        let response = JSON.parse(res);
        const { data } = response;
        this.authorData = data;
      }).catch((error) => {
        console.error('Error fetching author data:', error);
      });
    },
    sound() {
      var data = {
        albumId: this.albumId,
        userId: 0,
      };
      this.$api.soundList(data).then((res) => {
        //const response = JSON.stringify(res)
        let response = JSON.parse(res);
        this.soundList = response.data.data;

        // this.initSoundData();
      });
    },
    onPlaySound(index) {
      return;
      this.visible = false;
      this.currentSoundIndex = index;
      this.initSoundData();
    },
    initSoundData() {
      for (var i = 0; i < this.soundList.length; i++) {
        console.log(
          "this.soundList[i].album_sound_id",
          this.soundList[i].album_sound_id
        );
        if (this.soundList[i].album_sound_id === parseInt(this.albumSoundId)) {
          this.currentSoundIndex = i;
        }
      }

      let data = this.soundList[this.currentSoundIndex].soundInfo;
      console.log("data", data);
      if (parseInt(this.soundList[this.currentSoundIndex].is_free) === 1) {
        this.vipDialogVisible = true;
        return;
      }

      this.audioData = {
        url: data.url, // Required
        title: data.full_name, // Optional，Phone lock screen music player display
        artist: data.full_name, // Optional，Phone lock screen music player display
        totalTime: data.duration, // Optional，Phone lock screen music player display
        artwork: [
          {
            src: data.cover,
            sizes: "512x512",
            type: "image/png",
          },
        ],
      };
      this.visible = true;
      console.log("audioData", this.audioData);
    },
    getRandomKey() {
      return Math.random().toString(36).substr(2, 9);
    },
    openApp() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      var isAndroid = ua.indexOf("android") != -1;
      var isIos = ua.indexOf("iphone") != -1 || ua.indexOf("ipad") != -1;
      // 判断是不是在微信客户端打开
      if (isWeixin) {
        document.body.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'
        this.page = 2;
      } else {
        this.checkAppInstalled();
      }
    },
    checkAppInstalled() {
      // 判断系统环境
      let isAndroid = /Android/i.test(navigator.userAgent);
      let isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      let isIOSVersionAbove10 =
        isIOS && parseFloat(navigator.appVersion.split("OS ")[1]) >= 10;

      // 检查App是否安装
      if (isAndroid) {
        // Android检查App是否安装的方法
        this.checkAndroidAppInstalled();
      } else if (isIOSVersionAbove10) {
        // iOS 10.0及以上版本检查App是否安装的方法
        this.checkIosAppInstalled();
      } else {
        // 其他情况跳转到下载页面
        window.location.href = "/download";
      }
    },
    checkAndroidAppInstalled() {
      let intentUrl = `bunnyu://app.zuidie.net/open/album_player?albumId=${this.albumId}&albumSoundId=${this.albumSoundId}`;
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = intentUrl;
      document.body.appendChild(iframe);
      setTimeout(() => {
        document.body.removeChild(iframe);
        // 如果3秒内没有被唤起,说明App未安装,跳转到下载页面
        window.location.href = "/download";
      }, 3000);
    },
    checkIosAppInstalled() {
      // iOS检查App是否安装的具体实现
      let link = document.createElement("a");
      link.href = `bunnyu://app.zuidie.net/open/album_player?albumId=${this.albumId}&albumSoundId=${this.albumSoundId}`
      link.click();
      setTimeout(() => {
        // 如果3秒内没有被唤起,说明App未安装,跳转到下载页面
        window.location.href = "/download";
      }, 3000);
    },
    download() {
      window.location.href = "/download";
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    calculateContentHeight() {
      const clampedContent = this.$refs.clampedContent;
      if (clampedContent) {
        const lineHeight = 1.5; // 行高
        const maxLines = 6; // 最大行数
        const maxHeight = lineHeight * maxLines * 16; // 16px 是默认字体大小
        this.showToggleButton = clampedContent.scrollHeight > maxHeight;
      }
    },
  },
  created() {
    this.albumId = this.$route.query.albumId;
    this.albumSoundId = this.$route.query.albumSoundId;
    this.init();
    this.sound();
  },
  mounted() {},
};
</script>

<style scoped>
.aui-card-list-content-padded {
  position: relative;
}

.clampedCon {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4; /* 添加标准的 line-clamp 属性 */
  -webkit-box-orient: vertical;
  line-height: 1.5em;
  max-height: calc(4 * 1.5em);
  position: relative;
  transition: max-height 0.4s ease;
}

.clampedCon::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%; /* 水平方向上居中 */
  background: white; /* 背景色与背景一致，覆盖多余文字 */
  padding-right: 0.5em; /* 调整省略号的位置 */
  width: 50%; /* 覆盖第六行的后半段 */
  height: 1.5em; /* 与行高一致 */
  display: block;
}

.clampedCon.expanded {
  -webkit-line-clamp: unset;
  line-clamp: unset; /* 添加标准的 line-clamp 属性 */
  max-height: none;
}

/* 在展开时隐藏 ::after 伪元素 */
.clampedCon.expanded::after {
  content: ''; /* 移除内容 */
  display: none; /* 隐藏伪元素 */
}

.toggle-button {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: rgba(64, 64, 64, 1);
  margin-top: 0.8rem;
}

.expandedText {
  margin: 0 0.4rem;
}

.shadowLine {
  display: inline-block;
  width: 4.3rem;
  height: 0.025rem;
  opacity: 1;
  background: rgba(140, 140, 140, 0.6);
}
</style>


// WEBPACK FOOTER //
// src/page/album/info.vue